import api from './api';

const resourceAllocationService = {
  getAllResourceAllocations: async (params = {}) => {
    try {
      const response = await api.get('/resource-allocations', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching resource allocations:', error);
      throw error;
    }
  },

  getResourceAllocationById: async (id) => {
    try {
      const response = await api.get(`/resource-allocations/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching resource allocation with ID ${id}:`, error);
      throw error;
    }
  },

  createResourceAllocation: async (resourceAllocationData) => {
    try {
      const response = await api.post('/resource-allocations', resourceAllocationData);
      return response.data;
    } catch (error) {
      console.error('Error creating resource allocation:', error);
      throw error;
    }
  },

  updateResourceAllocation: async (id, resourceAllocationData) => {
    try {
      const response = await api.put(`/resource-allocations/${id}`, resourceAllocationData);
      return response.data;
    } catch (error) {
      console.error(`Error updating resource allocation with ID ${id}:`, error);
      throw error;
    }
  },

  deleteResourceAllocation: async (id) => {
    try {
      const response = await api.delete(`/resource-allocations/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting resource allocation with ID ${id}:`, error);
      throw error;
    }
  },

  getResourceAllocationStats: async () => {
    try {
      const response = await api.get('/resource-allocations/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching resource allocation stats:', error);
      throw error;
    }
  }
};

export default resourceAllocationService;

